import { Api as WtsApi } from 'src/api/swagger/wtsApi';
import { Api as EdeApi } from 'src/api/swagger/sleepwellMTS';
import { Api as HelpApi } from 'src/api/swagger/helpApi';
import communicate from 'src/api/communicate';
import conf from 'src/conf/conf';
import Utils from 'src/utils';
function getApiInstance(Api, baseURL) {
    const instance = new Api({ baseURL });
    instance.request = ({ method, path, body, query, format }) => {
        return communicate({
            method: method,
            url: path.slice(1),
            data: body,
            getParams: query ? Utils.objects.getQueryStringFromObject(query) : undefined,
            responseType: format,
            api: baseURL
            // abortController Use cancel token in Planner on refactor https://tarkvara.ektaco.ee/issues/28634
        });
    };
    return instance;
}
export const wtsApi = getApiInstance(WtsApi, conf.api);
export const edeApi = getApiInstance(EdeApi, conf.edePath);
export const helpApi = getApiInstance(HelpApi, conf.helpApi);
